export default __webpack_public_path__ + "static/Korin-bd198aa0aa2349699f5ff126c3c39fd9.png";